import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "NoTicket"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 4.5H20.5605L22.5 2.5605L21.4395 1.5L1.5 21.4395L2.5605 22.5L5.5605 19.5H21C21.8279 19.4988 22.4988 18.8279 22.5 18V14.25C22.5 13.8358 22.1642 13.5 21.75 13.5C20.9216 13.5 20.25 12.8284 20.25 12C20.25 11.1716 20.9216 10.5 21.75 10.5C22.1642 10.5 22.5 10.1642 22.5 9.75V6C22.4992 5.17192 21.8281 4.50083 21 4.5ZM21 9.09525C19.6754 9.43723 18.7499 10.632 18.7499 12C18.7499 13.368 19.6754 14.5628 21 14.9047V18H15.75V15.75H14.25V18H7.06049L14.25 10.8105V14.25H15.75V9.3105L19.0605 6H21V9.09525ZM3 9.09525V6H14.25V4.5H3C2.17192 4.50083 1.50083 5.17192 1.5 6V9.75C1.5 10.1642 1.83579 10.5 2.25 10.5C3.07843 10.5 3.75 11.1716 3.75 12C3.75 12.8284 3.07843 13.5 2.25 13.5C1.83579 13.5 1.5 13.8358 1.5 14.25V18H3V14.9047C4.32529 14.5633 5.2515 13.3682 5.2515 11.9996C5.2515 10.6311 4.32529 9.43596 3 9.0945V9.09525Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/NoTicket.vue"]]);
